import useAPI from '@/hooks/useAPI';
import { useQueryResponseMessage } from '@/hooks/useQueryResponseMessage';
import PersonRepository from '@/repositories/PersonRepository';

export const useSendAppInvite = ({
  personId,
  enabled = false
}: {
  personId: string;
  enabled?: boolean;
}) => {
  const personRepository = PersonRepository();
  const queryKey = ['sendAppInvite', personId];

  const queryResponse = useAPI({
    queryKey,
    queryFn: async () => {
      return await personRepository.sendAppInvite(personId);
    },
    enabled
  });

  const { data, dataUpdatedAt, isSuccess } = queryResponse;

  useQueryResponseMessage({
    dataUpdatedAt,
    isSuccess,
    queryKey,
    successMessage: data?.message || 'Successfully sent app invite'
  });

  return queryResponse;
};

export default useSendAppInvite;
